<div class="center-small-container">
  <h1 class="page-title-center">Email Change</h1>

  <mat-stepper
    linear
    [selectedIndex]="step()"
    (selectedIndexChange)="step.set($event)"
  >
    <mat-step [stepControl]="emailForm">
      <form
        class="account-update-form gap-15"
        [formGroup]="emailForm"
        (ngSubmit)="createToken()"
      >
        <mat-form-field appearance="outline" class="mt-10">
          <mat-label>New email</mat-label>
          <input matInput formControlName="email" />
        </mat-form-field>

        <button
          mat-flat-button
          class="mat-button-squared-full-width"
          type="submit"
          matTooltip="Continue"
          [disabled]="emailForm.invalid"
        >
          Continue
        </button>
      </form>
    </mat-step>

    <mat-step [stepControl]="userForm">
      <form
        class="account-update-form gap-15"
        [formGroup]="userForm"
        (ngSubmit)="updateEmail()"
      >
        <mat-form-field appearance="outline" class="mt-10">
          <mat-label>New email</mat-label>
          <input matInput formControlName="email" readonly />

          <button
            class="mr-7"
            mat-button
            matSuffix
            type="button"
            matTooltip="Edit email"
            (click)="changeEmail()"
          >
            Edit
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Code</mat-label>
          <input matInput formControlName="token_code" />
        </mat-form-field>

        @if (resendEmailCodeTimer() > 0) {
          <div class="yellow-container">
            Didn't get a code? Resend it in {{ resendEmailCodeTimer() }}
          </div>
        }

        @if (resendEmailCodeTimer() === 0) {
          <div class="yellow-container">
            Didn't get a code?
            <a matTooltip="Resend Verification Code" (click)="createToken()">
              Resend it
            </a>
          </div>
        }

        <button
          mat-flat-button
          class="mat-button-squared-full-width"
          type="submit"
          matTooltip="Update"
          [disabled]="userForm.invalid"
        >
          Update
        </button>
      </form>
    </mat-step>
  </mat-stepper>

  <div class="bottom-actions">
    <button mat-button (click)="goBack()" matTooltip="Go back">
      Go back
    </button>
  </div>
</div>